<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Logs</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Logs</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- {{formParamSt}} -->
          <!-- /Page Header -->
          <!-- {{serverParams}} -->
          <!-- Search Filter -->
          <!-- {{selectAllTable}}-->
          <!-- {{selectedTable}} -->
          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <!-- <div class="cal-icon"> -->
                <input
                  v-model="serverParams.columnFilters.start_date"
                  class="form-control floating"
                  type="date"
                />
                <!-- </div> -->
                <label class="focus-label sr-only">From</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <!-- <div class="cal-icon"> -->
                  <input
                    v-model="serverParams.columnFilters.end_date"
                    class="form-control floating"
                    type="date"
                  />
                  <!-- </div> -->
                  <div class="input-group-append">
                    <a
                      title="Show search options"
                      class="btn btn-primary"
                      @click="showSearchForm()"
                      href="#"
                      data-toggle="modal"
                      data-target="#search_form"
                    >
                      <i class="fa fa-list"></i>
                      <i
                        class="fa fa-circle"
                        v-if="formParamSt.more_search == true"
                      ></i>
                    </a>
                  </div>
                </div>

                <label class="focus-label sr-only">To</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <a
                  href="javascript:void(0)"
                  @click.prevent="searchData"
                  class="btn btn-success btn-block"
                  >Search</a
                >
              </div>
            </div>
          </div>
          <!-- /Search Filter -->

          <div class="row">
            <template v-if="loading">
              <div class="col-md-12">
                <skeleton :count="1" />
              </div>
            </template>
            <template v-if="rows.length">
              <div
                v-for="(row, index) in rowsSummary"
                :key="index"
                class="col-md-6 col-sm-6 col-lg-6 col-xl-3"
              >
                <div class="card dash-widget">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i
                        v-if="row.label == 'total_like'"
                        class="fa fa-thumbs-up"
                      ></i>
                      <i
                        v-if="row.label == 'total_play'"
                        class="fa fa-play"
                      ></i>
                      <i
                        v-if="row.label == 'total_comment'"
                        class="fa fa-comment"
                      ></i>
                      <i
                        v-if="row.label == 'total_impressions'"
                        class="fa fa-eye"
                      ></i>
                      <i
                        v-if="row.label == 'total_reach'"
                        class="fa fa-podcast"
                      ></i>
                      <i
                        v-if="row.label == 'total_interactions'"
                        class="fa fa-users"
                      ></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3>{{ row.total | angkaKMB }}</h3>
                      <span v-if="row.label == 'total_like'">Like</span>
                      <span v-if="row.label == 'total_play'">Play</span>
                      <span v-if="row.label == 'total_comment'">Comment</span>
                      <span v-if="row.label == 'total_impressions'"
                        >Impression</span
                      >
                      <span v-if="row.label == 'total_reach'">Reach</span>
                      <span v-if="row.label == 'total_interactions'"
                        >Interactions</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="rows.length < 1 && !loading">
              <div class="col-md-12 text-center">-empty-</div>
            </template>
          </div>

          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <!-- <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center" rowspan="2">No.</th>
                      <th class="text-center" rowspan="2">Brand</th>
                      <th class="text-center" rowspan="2">Account</th>
                      <th class="text-center" rowspan="2">Post</th>
                      <th class="text-center" colspan="4">Statistics</th>
                      <th class="text-center" rowspan="2">Media Type</th>
                      <th class="text-center" rowspan="2">Status</th>
                      <th class="text-center" rowspan="2">Last Modified</th>
                    </tr>
                    <tr style="box-shadow: none;">
                      <th class="text-wrap">Total Like</th>
                      <th class="text-wrap">Total Play</th>
                      <th class="text-wrap">Total Comments</th>
                      <th class="text-wrap">Engagement Rate (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="11">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-right">{{ row.number }}</td>
                        <td class="text-wrap">
                          <div :ref="'brand-' + row.id">
                            <Skeleton :count="1" />
                          </div>
                        </td>
                        <td class="text-wrap" :ref="'account-' + row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td class="text-wrap">
                          <div class="text-center" v-if="row.assets_url != ''">
                            <carousel
                              :navigateTo="0"
                              :autoplay="true"
                              :paginationEnabled="false"
                              :perPage="1"
                              :navigationEnabled="true"
                              :centerMode="true"
                              :paginationActiveColor="'#00bddc'"
                              :paginationColor="'#99e8ff'"
                            >
                              <slide
                                v-for="(imgSrc, idx) in JSON.parse(
                                  row.assets_url
                                )"
                                data-index="0"
                                :key="idx"
                              >
                                <img :src="imgSrc" style="width:200px" />
                              </slide>
                            </carousel>
                          </div>
                          <div class="text-muted">
                            {{ row.caption.substr(0, 100) }}
                          </div>
                        </td>
                        <td class="text-right">{{ row.total_like }}</td>
                        <td class="text-right">{{ row.total_play }}</td>
                        <td class="text-right">{{ row.total_comment }}</td>
                        <td class="text-right">
                          {{ row.total_engagement_rate }}
                        </td>
                        <td class="text-center">
                          <span class="badge badge-primary">{{
                            row.media_type
                          }}</span>
                        </td>
                        <td class="text-wrap">
                          <div v-if="row.post_status == 2">
                            <span class="badge badge-success">Published</span>
                            <br />
                            <a
                              :href="
                                'https://www.instagram.com/p/' +
                                  row.instagram_media_code
                              "
                              target="_blank"
                              >{{ row.instagram_media_code }}</a
                            >
                          </div>
                          <div v-else-if="row.post_status == 1">
                            <span class="badge badge-info">Connecting...</span>
                          </div>
                          <span v-else class="badge badge-danger">Failed</span>
                          <div
                            v-if="row.post_status == 0"
                            class="text text-danger"
                          >
                            <small>{{ row.post_reason }}</small>
                          </div>
                        </td>
                        <td class="text-wrap">
                          {{ formatLocalDate(row.update_datetime) }}
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="11" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div> -->
              <div class="row align-items-start">
                <template v-if="loading">
                  <div class="col-md-12">
                    <skeleton :count="1" />
                  </div>
                </template>
                <template v-if="rows.length">
                  <div
                    v-for="(row, index) in rows"
                    :key="index"
                    class="col-md-6 col-xl-4 pb-4"
                  >
                    <div class="of-card">
                      <div class="of-card-top"></div>
                      <div class="of-card-header">
                        <div class="of-card-h-1">
                          <div class="of-card-h-2">
                            <div class="of-card-h-3">
                              <div class="of-card-h-4">
                                <img
                                  :src="require('@/assets/user.jpg')"
                                  alt=""
                                  class="of-card-h-5"
                                />
                              </div>
                            </div>
                            <div class="of-card-h-6">
                              <div
                                class="of-card-h-7"
                                :ref="'account-' + row.id"
                              >
                                <Skeleton :count="1" />
                              </div>
                              <div class="of-card-h-8">
                                {{ formatLocalDate(row.update_datetime) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="of-card-body">
                        <div class="of-card-body-a">
                          <div class="of-card-body-cap">
                            <div class="of-card-body-cap-1">
                              <p
                                :title="row.caption"
                                class="of-card-body-cap-2"
                              >
                                {{ row.caption }}
                              </p>
                            </div>
                          </div>
                          <div class="of-card-body-img">
                            <template
                              v-if="JSON.parse(row.assets_url).length > 0"
                            >
                              <img
                                v-if="
                                  JSON.parse(row.assets_url)[0].includes(
                                    '.jpg'
                                  ) ||
                                    JSON.parse(row.assets_url)[0].includes(
                                      '.jpeg'
                                    )
                                "
                                title="Lihat Gambar"
                                @click="
                                  openImage(JSON.parse(row.assets_url)[0])
                                "
                                style="cursor: zoom-in"
                                class="of-card-body-img-p"
                                :src="JSON.parse(row.assets_url)[0]"
                                :alt="row.caption"
                              />
                              <!-- <iframe
                                style="width: 100%; height: 100%; overflow: hidden;"
                                v-else-if="
                                  JSON.parse(row.assets_url)[0].includes('.mp4')
                                "
                                allow="autoplay; picture-in-picture"
                                allowfullscreen
                                frameborder="0"
                                :src="
                                  JSON.parse(row.assets_url)[0] + '?autoplay=0'
                                "
                                :title="row.caption"
                              /> -->
                              <video
                                style="
                                  width: 100%;
                                  height: 100%;
                                  overflow: hidden;
                                "
                                v-else-if="
                                  JSON.parse(row.assets_url)[0].includes('.mp4')
                                "
                                controls
                              >
                                <source
                                  :src="JSON.parse(row.assets_url)[0]"
                                  type="video/mp4"
                                />
                              </video>
                              <img
                                v-else
                                class="of-card-body-img-p"
                                :src="require('@/assets/placeholder.jpg')"
                                alt=""
                              />
                            </template>
                            <template v-else>
                              <img
                                class="of-card-body-img-p"
                                :src="require('@/assets/placeholder.jpg')"
                                alt=""
                              />
                            </template>
                          </div>
                        </div>
                        <div class="of-card-body-b"></div>
                        <div class="of-card-body-c">
                          <table class="of-card-table">
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Brand</td>
                                <td class="of-card-td-r">
                                  <div
                                    style="width: 150px"
                                    :ref="'brand-' + row.id"
                                  >
                                    <Skeleton :count="1" />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Media Type</td>
                                <td class="of-card-td-r">
                                  <span class="badge badge-primary">{{
                                    row.media_type
                                  }}</span>
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Like</td>
                                <td class="of-card-td-r">
                                  {{ row.total_like }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Play</td>
                                <td class="of-card-td-r">
                                  {{ row.total_play }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Comments</td>
                                <td class="of-card-td-r">
                                  {{ row.total_comment }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Impressions</td>
                                <td class="of-card-td-r">
                                  {{ row.total_impressions }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Reach</td>
                                <td class="of-card-td-r">
                                  {{ row.total_reach }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Interactions</td>
                                <td class="of-card-td-r">
                                  {{ row.total_interactions }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr style="border: none">
                                <td class="of-card-td-l">Status</td>
                                <td class="of-card-td-r">
                                  <div v-if="row.post_status == 2">
                                    <span class="badge badge-success"
                                      >Published</span
                                    >
                                    <a
                                      :href="
                                        'https://www.instagram.com/p/' +
                                          row.instagram_media_code
                                      "
                                      target="_blank"
                                      ><i
                                        style="font-size: 16px;"
                                        class="la la-external-link"
                                      ></i
                                    ></a>
                                  </div>
                                  <div v-else-if="row.post_status == 1">
                                    <span class="badge badge-info"
                                      >Connecting...</span
                                    >
                                  </div>
                                  <span v-else class="badge badge-danger"
                                    ><VueCustomTooltip
                                      :label="row.post_reason"
                                      multiline
                                      position="is-left"
                                      >Failed</VueCustomTooltip
                                    ></span
                                  >
                                </td>
                              </tr>
                            </tbody>
                            <!-- <tbody v-if="row.post_status == 0">
                              <tr style="border: none;">
                                <td class="of-card-td-l">
                                  <div class="text text-danger">
                                    <small>{{ row.post_reason }}</small>
                                  </div>
                                </td>
                              </tr>
                            </tbody> -->
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="rows.length < 1 && !loading">
                  <div class="col-md-12 text-center">-empty-</div>
                </template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width: 100px"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchDataMore" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import {
  getFirstLastDayInWeek,
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo,
  marketplaceLabelFilter,
  formatLocalDateWithDay,
  formatHourFromUnix,
  convertUTCDatetimeToUnix,
  currentDateTimeUnix
} from "@/utils/helper";
import FormData from "./form.vue";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    Carousel,
    Slide
  },
  data() {
    return {
      linkExcel: "",
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      rowsSummary: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          start_date: "",
          end_date: "",
          instagram_account_id: "",
          brand_id: "",
          media_type: "",
          is_official: "1"
        },
        page: 1,
        perPage: 20, // perPage
        more_search: false
      }
    };
    //  isactive : true
  },
  computed: {
    formParamSt() {
      return this.$store.state.instagramSchedule.formParamListLogStB;
    },
    isShowForm() {
      return this.$store.state.instagramSchedule.isShowForm;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {},
  filters: {
    angkaKMB(value) {
      if (value >= 1e9)
        return (
          ((value / 1e9) % 1 === 0 ? value / 1e9 : (value / 1e9).toFixed(2)) +
          "B"
        );
      if (value >= 1e6)
        return (
          ((value / 1e6) % 1 === 0 ? value / 1e6 : (value / 1e6).toFixed(2)) +
          "M"
        );
      if (value >= 1e3)
        return (
          ((value / 1e3) % 1 === 0 ? value / 1e3 : (value / 1e3).toFixed(2)) +
          "K"
        );
      return value;
    }
  },
  created() {
    this.getFirstLastDayInWeek();
    this.loadItems();
    this.summaryLogs();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    openImage(url) {
      window.open(url, "_blank");
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },

    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },

    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },

    formatDateForMessage(utcDateTime, format) {
      return formatDateForMessage(utcDateTime, format);
    },
    getFirstLastDayInWeek() {
      // let days = getFirstLastDayInWeek();
      // this.serverParams.columnFilters.start_date = this.formatDateForMessage(
      //   days.firstday,
      //   "ISODate"
      // );
      // this.serverParams.columnFilters.end_date = this.formatDateForMessage(
      //   days.lastday,
      //   "ISODate"
      // );
    },
    showSearchForm() {
      this.$store.dispatch("instagramSchedule/setIsShowForm", false);
      this.$store.dispatch(
        "instagramSchedule/actFormParamListLogStB",
        this.serverParams
      );
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("search_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("instagramSchedule/setIsShowForm", true);
        }
      }, 1000);
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
      await this.summaryLogs();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
        await this.summaryLogs();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
        await this.summaryLogs();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
      await this.summaryLogs();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.linkExcel = "";
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      await this.summaryLogs();
      this.loading = await false;

      await this.$store.dispatch(
        "instagramSchedule/actFormParamListLogStB",
        this.serverParams
      );
    },
    async searchDataMore() {
      this.linkExcel = "";

      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.serverParams = this.formParamSt;
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      await this.summaryLogs();
      this.loading = await false;
    },

    async summaryLogs() {
      this.loading = await true;
      await this.$store
        .dispatch("instagramSchedule/summaryLogs", this.serverParams)
        .then(response => {
          const { data } = response;
          this.rowsSummary = data;
          console.log(rowsSummary);
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },

    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("instagramSchedule/listLogs", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let detailId = row.brand_id;
              this.$store
                .dispatch("brand/detail", detailId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["brand-" + row.id][0].innerHTML = resData.name;
                });

              if (
                row.instagram_account_id != "" &&
                row.instagram_account_id != null
              ) {
                this.$store
                  .dispatch("instagramAccount/detail", row.instagram_account_id) // sesuai kan dengan method di API
                  .then(responseDet => {
                    var resData = responseDet.data;
                    this.$refs["account-" + row.id][0].innerHTML =
                      "<a href='https://www.instagram.com/" +
                      resData.username +
                      "/' target='_blank'>" +
                      resData.username +
                      "</a>";
                  });
              } else {
                this.$refs["account-" + row.id][0].innerHTML =
                  "failed getting account detail";
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>

<style scoped>
.of-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;
  background-color: rgb(255, 255, 255);
  border-color: rgb(222, 225, 225);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
}
.of-card-top {
  background-color: rgb(228, 64, 95);
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  height: 8px;
}
.of-card-header {
  padding: 8px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-radius: 8px 8px 0px 0px;
  font-size: 13px;
  line-height: 21.3333px;
  border-color: rgb(222, 225, 225);
}
.of-card-h-1 {
  padding: 8px;
  width: 100%;
  overflow: hidden;
}
.of-card-h-2 {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.of-card-h-3 {
  margin-right: 12px;
}
.of-card-h-4 {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: flex;
  position: relative;
  flex-shrink: 0;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  color: rgb(39, 51, 51);
  background: rgb(222, 225, 225);
}
.of-card-h-5 {
  display: block;
  margin: 0px;
  width: auto;
  height: 100%;
  max-width: 100%;
}
.of-card-h-6 {
  overflow: hidden;
}
.of-card-h-7 {
  margin: 0px;
  padding-left: 0px;
  padding-right: 0px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  color: rgb(54, 65, 65);
  font-size: 13px;
  line-height: 21.3333px;
}
.of-card-h-8 {
  color: rgb(54, 65, 65);
  font-weight: 400;
  font-size: 11px;
  line-height: 18.6667px;
}
.of-card-body {
  padding: 16px;
  font-size: 16px;
  line-height: 24px;
  border-color: rgb(222, 225, 225);
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
}
.of-card-body-a {
  display: flex;
  flex-direction: column;
}
.of-card-body-cap {
  margin-bottom: 12px;
  height: 63.98px;
}
.of-card-body-cap-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
}
.of-card-body-cap-2 {
  font-size: 13px;
  line-height: 21.3333px;
  color: #364141;
}
.of-card-body-img {
  border: 1px solid rgb(222, 225, 225);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 299px;
  background-color: #f7f7f7;
}
.of-card-body-img-p {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: 100%;
}
.of-card-body-b {
  padding-bottom: 16px;
}
.of-card-body-c {
  display: flex;
}
.of-card-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.of-card-table tbody:first-child td {
  padding-top: 0px;
}
.of-card-table tbody td:first-child {
  padding-left: 0px;
  width: 100%;
  max-width: 0px;
}
.of-card-table tbody td {
  padding-bottom: 8px;
}
.of-card-table tbody tr {
  border-bottom: 1px solid rgb(222, 225, 225);
}
.of-card-td-l {
  font-size: 13px;
  line-height: 21.3333px;
  font-weight: 400;
  padding: 8px;
  text-align: left;
  color: rgb(81, 94, 95);
}
.of-card-td-r {
  font-size: 13px;
  line-height: 21.3333px;
  padding: 8px;
  text-align: right;
  color: rgb(81, 94, 95);
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/instagram/instagramLogsOfficial/list.vue